module.exports = __webpack_public_path__ + "static/family-mobile-68181ba431a01f752f65b52835bf0c5c.png";